<template>

  <div class="main">
    <van-nav-bar title="编写短信"
                 left-arrow
                 @click-left="onClickLeft"/>
    <van-notice-bar
        left-icon="volume-o"
        text="请勿发送违规信息，否则将报警移交给相关公安机关处理，短信大概1-10分钟的延迟，22点-8点延迟时间较大，介意请在8点后发送信息。"
    />
    <van-form class="form" @submit="submit">

      <van-cell-group class="item" inset>
        <van-field v-model="phone" type="tel"
                   placeholder="请输入对方手机号"
                   clearable
                   :rules="[{ pattern, message: '请输入正确的手机号' }]"/>
      </van-cell-group>

      <van-cell-group class="item" inset>
        <van-field v-model="sendTime" @click="showTimePopup" placeholder="预约发送时间" right-icon="arrow" readonly
                   :rules="[{ required: true, message: '请选择短信发送时间' }]"/>

        <van-popup v-model:show="show" position="bottom">
          <van-datetime-picker
              v-model="currentDate"
              type="datetime"
              title="请选择短信发送时间"
              :min-date="minDate"
              @cancel="show = false"
              @confirm="submitTime"
          />
        </van-popup>
      </van-cell-group>
      <van-cell-group class="item no-line" inset>
        <SmsContentTextarea
            v-model="smsContent"
            :maxlength="2000"
            required
            placeholder="点击输入传话内容（情感、表白、早晚安、道歉、 祝福…）禁止发送包含辱骂、破环他人关系等违规信息"
            :unit-price="2"
        />
      </van-cell-group>
      <div class="form-item anonymous-line">
        <van-checkbox v-model="anonymous" checked-color="#00D477">
          匿名发送
        </van-checkbox>
        <!--        <input class="name-input " placeholder="请输入你的称呼"/>-->
        <div v-if="!anonymous" class="van-hairline--bottom name-input">
          <van-field class="name-input-field" v-model="name" placeholder="请输入你的称呼"/>
        </div>
        <!--        <van-field class="name-input" v-model="name" placeholder="请输入你的称呼"/>-->
      </div>

      <div class="center">

        <van-button class="submit-btn" round block type="primary" color="#00D477" native-type="submit"
                    @click="submitType='submit'">
          发送
        </van-button>
<!--        <div class="sms-price-explain">-->
<!--          当支付异常时请选择备用发送通道发送-->
<!--        </div>-->

<!--        <van-button class="submit-btn" round block type="primary" color="#00D477" native-type="submit"-->
<!--                    @click="submitType='toMa'">-->
<!--          备用发送通道-->
<!--        </van-button>-->

      </div>

    </van-form>
<!--    <div class="preview-sms" @click="preview">-->
<!--      预览短信-->
<!--    </div>-->
    <div class="sms-price-explain">
      短信发送价格：45字/2元
    </div>
    <van-popup v-model:show="previewSms" :style="{ height: '40%' }" style="background-color: #f7f7f7" closeable
               position="bottom">
      <div class="center-column">
        <div class="preview-date" style="color: #999">
          {{ previewDate }}
        </div>
        <div class="preview-box">
          <div class="preview-box-from">
            10691828543590
          </div>
          <div class="preview-box-item">
            {{ smsContent }}
          </div>
          <div class="preview-box-item" style="width: 100%; text-align: right!important;">
            {{ name }}
          </div>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model:show="showBindPhoneDialog" :before-close="beforeClose" title="绑定手机号"
                show-cancel-button>
      <div class="phone-tips">
        根据监管部门要求，用户需要进行手机号码验证，验证后平台将保护您的个人隐私不会泄露，不会使用您的手机号进行发短信和打电话！
      </div>
      <van-form>
        <van-cell-group inset>
          <van-field
              v-model="form.phone"
              label="手机号"
              placeholder="请输入手机号"
              type="tel"
              clearable
          />
          <van-field
              v-model="form.code"
              class="code"
              center
              clearable
              type="tel"
              label="验证码"
              placeholder="请输入短信验证码"
          >
            <template #button>
              <van-button size="small" class="get-code" type="primary" color="#00D477" @click.prevent="sendSmsCode"
                          :disabled="isSmsSend">{{ sendBtnText }}
              </van-button>
            </template>
          </van-field>
        </van-cell-group>

      </van-form>
    </van-dialog>
    <van-dialog v-model:show="showToMaDialog" show-cancel-button>
      <wx-open-launch-weapp
          id="launch-btn"
          appid="wx38d23f92c7f91444"
          username="gh_df081dcddd39"
          :path="dynamicPath"
          env-version="trial" >

        <div v-is="'script'" type="text/wxtag-template">
          <button style="width:200px;height:44px;background:#07c160;color:white;border:none;border-radius:8px;">
            去小程序支付
          </button>
        </div>
      </wx-open-launch-weapp>
    </van-dialog>

    <TermsDialog
        :visible="showTermsDialog"
        @confirm="showTermsDialog = false"
    />

  </div>

</template>

<script>
import {NavBar, Form, Field, CellGroup, Popup, DatetimePicker, Button, Checkbox, Dialog, Toast, NoticeBar} from 'vant';
import TermsDialog from "@/components/TermsDialog.vue";
import SmsContentTextarea from "@/components/SmsContentTextarea.vue";
import dayjs from 'dayjs'
import {createOneYuanOrder, createSmsOrderV2, createSmsOrderCache} from "../api/order";
import {createSms} from "../api/sms";
import wx from "weixin-js-sdk";
import {getJsAPiSign, getUserInfo, bindPhone, getCode} from "../api/user";

export default {
  name: "write",
  setup() {
    const pattern = /1[3-9]\d{9}$/;
    return {
      pattern,
    };
  },
  data() {
    return {
      showTermsDialog: true,
      dynamicPath: "",
      phone: '',
      showToMaDialog: false,
      smsContent: '',
      smsDate: '',
      show: false,
      anonymous: true,
      sendTime: '',
      orderId: '',
      currentDate: new Date(),
      // minDate: new Date(),
      minDate: dayjs().add(2, 'm').toDate(),
      name: '',
      previewSms: false,
      previewDate: '',
      isPay: false,
      isBindPhone: true,
      showBindPhoneDialog: false,
      form: {
        phone: '',
        code: ''
      },
      // 是否已经发送了验证码
      isSmsSend: false,
      sendBtnText: '发送验证码',
      timer: null,
      counter: 60,
      pattern: /1[3-9]\d{9}$/,
      submitType: 'submit',

    }
  },

  created() {
    let url = {'url': window.location.href}
    getJsAPiSign(url)
        .then(res => {
          wx.config({
            debug: false, // 开启调试模式,
            appId: res.data.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature,// 必填，签名，见附录1
            jsApiList: ['chooseWXPay'], // 必填，需要使用的JS接口列表，所有JS接口列
            openTagList: ["wx-open-launch-weapp"],
          });
        })
    getUserInfo().then(res => {

      if (res.data.code === '00000') {
        if (res.data.data.phone != null && res.data.data.phone !== '') {
          this.isBindPhone = true
        } else {
          this.isBindPhone = false
        }
      }
    })
  },
  mounted() {
    // this.openTermsDialog();
  },
  beforeDestroy() {
    Toast.clear()
  },


  methods: {
    onClickLeft() {
      this.$router.push({
        path: "/index"
      })
    },

    async handleLaunch(e) {
      console.log("用户点击了打开小程序按钮");

      // 阻止默认打开（必须）
      e.preventDefault();
      if (this.isBlank(this.phone) || !this.pattern.test(this.phone) || this.isBlank(this.sendTime)  || this.isBlank(this.smsContent) ) {
        Toast.fail("请先填写信息")
        return;
      }
      try {
        // 1. 发送请求，获取后端返回的页面路径
        let form = {
          phone: this.phone,
          content: this.smsContent,
          sendTime: this.sendTime,
          sendName: this.name,
          isChat: false,
        }

        const res = await createSmsOrderCache(form);

        const amount = Math.ceil(this.smsContent.length / 45);
        // 2. 后端返回动态路径
        // 示例：pages/qrcode/qrcode?userId=123
        this.dynamicPath = "pages/pay/pay?orderId="+res.data.data.orderId+"&amount="+amount;

        // 3. 等待 DOM 更新路径
        await this.$nextTick();

        // 4. 继续执行打开小程序
        e.detail.open();
      } catch (err) {
        console.log("请求路径失败");
      }
    },
    isBlank(str){
      return str === null || str === undefined || str.trim() === '';
    },

    submit() {
      console.log(this.submitType)

      if (!this.isBindPhone) {
        this.showBindPhoneDialog = true
        return
      }
      // ============= 根据不同按钮执行不同逻辑 =============
      if (this.submitType === 'submit') {
        // 正常提交
        this.createOrder();
      } else if (this.submitType === 'toMa') {
        // 快速提交 / 其他逻辑（你自己加）
        let form = {
          phone: this.phone,
          content: this.smsContent,
          sendTime: this.sendTime,
          sendName: this.name,
          isChat: false,
        }
        createSmsOrderCache(form)
            .then(res => {
              if (res.data.code === '00000') {
                this.orderId = res.data.data.orderId
                console.log(res.data)
                const amount = Math.ceil(this.smsContent.length / 45);
                this.dynamicPath = "pages/pay/pay?orderId="+res.data.data.orderId+"&amount="+amount;
                this.showToMaDialog = true;
              }
            })
      }


    },
    createOrder() {
      let form = {
        phone: this.phone,
        content: this.smsContent,
        sendTime: this.sendTime,
        sendName: this.name,
        isChat: false,
      }
      createSmsOrderV2(form)
          .then(res => {
            if (res.data.code === '00000') {
              this.orderId = res.data.data.orderId
              this.pay(res.data.data)
            }
          })
    },

    toBindPhone() {
      if (this.form.code.length !== 6) {
        Toast('请输入验证码')
        return
      }
      bindPhone(this.form).then(res => {
        if (res.data.code === '00000') {
          this.showBindPhoneDialog = false
          this.isBindPhone = true
          Toast("绑定成功")
        } else if (res.data.code === '00007') {
          Toast("验证码错误")
        } else if (res.data.code === '00008') {
          Toast("手机号已被其他用户绑定，请更换手机号")
        } else {
          Toast("绑定失败")
        }
      })
    },
    cancelBindPhone() {
      this.showBindPhoneDialog = false
    },
    submitTime(dateTime) {
      this.currentDate = dateTime;

      this.sendTime = dayjs(dateTime).format("YYYY-MM-DD HH:mm");
      this.show = false;
    },
    showTimePopup() {
      this.show = true;
    },
    preview() {
      this.previewSms = true;
      this.previewDate = dayjs(new Date()).format("YYYY年MM月DD日 HH:mm")
    },
    pay(data) {
      let that = this
      wx.chooseWXPay({
        appId: data.appId,
        timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
        package: data.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: data.signType, // 签名方式,必须跟统一下单接口签名方式一致
        paySign: data.paySign, // 支付签名
        success: function (res) {
          if (res.errMsg == "chooseWXPay:ok") {
            //支付成功后跳转的页面
            console.log('支付成功')
            that.isPay = true
            Toast.success({
              message: '创建成功',
              duration: 3000
            })
          }
        },
        // 支付取消回调函数
        cencel: function (res) {
          that.isPay = false
          console.log('支付取消')
        },
        // 支付失败回调函数
        fail: function (res) {
          that.isPay = false
          console.log('支付失败')
        }
      })
    },
    /**
     * 重置倒计时
     */
    reset() {
      this.isSmsSend = false
      this.sendBtnText = '发送验证码'
      if (this.timer) {
        clearInterval(this.timer)
        this.counter = 60
        this.timer = null
      }
    },
    /**
     * 倒计时
     */
    countDown() {
      this.timer = setInterval(() => {
        this.sendBtnText = `${this.counter}秒`
        this.counter--
        if (this.counter < 0) {
          this.reset()
        }
      }, 1000)
    },
    /**
     * 发送验证码
     */
    sendSmsCode() {
      // 判断手机号是否已经输入

      if (!this.form.phone) {
        Toast('请输入手机号')
        return false
      }
      // 判断手机号是否符合要求
      console.log(this.pattern.test(this.form.phone))
      if (!this.pattern.test(this.form.phone)) {
        Toast('请输入正确的手机号码')
        return false
      }
      // 调用接口，发送短信验证码
      this.isSmsSend = true
      // 开始倒计时，60s之后才能再次点击
      this.countDown()
      console.log(this.form.phone)
      let tel = {'phone': this.form.phone}
      getCode(tel).then(res => {
        if (res.data.code === '00000') {
          Toast("发送成功，验证码5分钟内有效")
        } else {
          Toast("获取失败")
          this.reset()
        }
      })
    },
    async beforeClose(action) {
      return new Promise(async (resolve) => {
        if (action === 'confirm') {
          if (this.form.code.length !== 6) {
            Toast('请输入验证码')
            resolve(false);
            return
          }
          await bindPhone(this.form).then(res => {
            if (res.data.code === '00000') {
              this.showBindPhoneDialog = false
              this.isBindPhone = true
              Toast("绑定成功")
            } else if (res.data.code === '00007') {
              Toast("验证码错误")
              resolve(false);
            } else if (res.data.code === '00008') {
              Toast("手机号已被其他用户绑定，请更换手机号")
              resolve(false);
            } else {
              Toast("绑定失败")
              resolve(false);
            }
          }).catch(res => {
            Toast("绑定失败")
            resolve(false);
          })
          resolve(true);
        } else {
          resolve(true);
        }
      });
    },
  }
  ,
  components: {
    [NoticeBar.name]: NoticeBar,
    TermsDialog,
    [NavBar.name]:
    NavBar,
    [Field.name]:
    Field,
    [CellGroup.name]:
    CellGroup,
    [Form.name]:
    Form,
    [Popup.name]:
    Popup,
    [DatetimePicker.name]:
    DatetimePicker,
    [Button.name]:
    Button,
    [Checkbox.name]:
    Checkbox,
    [Toast.name]:
    Toast,
    [Dialog.Component.name]:
    Dialog.Component,
    SmsContentTextarea,
  }
}
</script>

<style scoped>
:deep(.no-line.van-cell-group::after),
:deep(.no-line .van-cell::after) {
  display: none !important;
}


.main {
  height: 100vh;
  background-color: #f7f7f7;
}


.item {
  margin-top: 15px;
  box-sizing: border-box;
}

.form-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 15px;
  margin-top: 15px;
  background-color: #f7f7f7;
}

.anonymous-line {
  min-height: 45px;
}

.name-input {
  width: 150px;
}

.name-input-field {
  background-color: #f7f7f7;
}

.submit-btn {
  align-items: center;
  width: 160px;
}

.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 15px;
  padding-top: 15px;
  background-color: #f7f7f7;
  box-sizing: border-box;
}

.center-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 15px;
  padding-top: 15px;
  padding-right: 15px;
  background-color: #f7f7f7;
}

.preview-sms {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #5c678d;
  font-size: 14px;
  height: 44px;
  background-color: #f7f7f7;
}

.sms-price-explain {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #999999;
  font-size: 12px;
  height: 30px;
  background-color: #f7f7f7;
}

.preview-date {
  font-size: 14px;
}

.preview-box {
  min-height: 80px;
  background-color: white;
  border-radius: 15px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 15px;
}

.preview-box-from {
  color: #e6e6e6;
  font-size: 16px;
}

.preview-box-item {
  color: #292833;
  line-height: 20px;
  margin-top: 10px;
  font-size: 14px;
}

.phone-tips {
  font-size: 13px;
  margin: 15px;
  color: #9ca3af;
}
</style>